<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.schedule') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.schedule') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <FullCalendar 
          class="calendar"
          defaultView="dayGridMonth"
          :plugins="calendarPlugins" 
          schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
          :events="data"
          :locale="$i18n.locale"
          :header="header"
          :buttonText="buttonText"
          />
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
import FullCalendar from '@fullcalendar/vue'
import { PluginDef } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import allLocales from '@fullcalendar/core/locales-all'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'

import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'
import '@fullcalendar/list/main.css'

export default {
  name: 'Schedule',
  components: {
    FullCalendar
  },
  data: function() {
  return {
      data: null,
      calendarPlugins: [ dayGridPlugin, listPlugin, interactionPlugin ],
      header: { 
        left: 'today prev,next',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,dayGridDay,listWeek' 
      },
      buttonText: {
        today: this.$t('schedule.today'),
        month: this.$t('schedule.month'),
        week: this.$t('schedule.week'),
        day: this.$t('schedule.day'),
        list: this.$t('schedule.list')
      }
  }
  },
  watch: {
    
  },
  methods: {
    loadData: function() {
      let that = this,
          userId = localStorage.getItem('token')

    this.$http.get(this.API3_PREFIX + 'schedule?userId=' + userId).then(function (response) {
    that.data = response.data
    that.data.forEach(function(v) {
      if (v.title == null) {
        v.title = that.$t('meeting.unknown')
        if (v.meetingType) {
          v.title = that.getMeetingType(v.meetingType)
        }
      }
    })
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>